import * as Yup from 'yup';

export const amountRegex = new RegExp('^[-+]?[0-9]*[$.,]?[0-9]+$');
export const inputValidatorRegEx = /^\s*-?(\d+(\.\d{1,2})?|\.\d{1,2})\s*$/;

export const oneTimePaymentDetailsFormValidationSchema = Yup.object().shape({
  paymentAmountDueType: Yup.string().required(
    'Amount Due selection is Required'
  ),
  paymentMinimumAmountDue: Yup.string().required(
    'Amount Due selection is Required'
  ),
  paymentOtherAmountDue: Yup.string().when('paymentAmountDueType', {
    is: 'other',
    then: Yup.string()
      .matches(inputValidatorRegEx, 'Enter a valid amount')
      .required('Amount Due Entry is Required')
      .test(
        'max amount test',
        `Please enter a valid amount of $2999.99 or less. If you’d like to pay your loan in full, please contact Bridgecrest or visit Bridgecrest.com.`,
        (val) => Number(val) < 3000
      )
      .when('paymentMinimumAmountDue', (paymentMinimumAmountDue, schema) => {
        return schema.test({
          test: (paymentOtherAmountDue: any) =>
            Number(paymentOtherAmountDue) > 0,
          message: 'Please enter an amount greater than $0.00',
        });
      }),
  }),
  paymentConsent: Yup.bool().oneOf([true], 'Consent is required to continue'),
});
